import { AfterViewInit, Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TimeslotRow } from '../../providers/timeslots-provider';
import moment from 'moment';
import {
  MAT_DIALOG_DATA, MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgIf } from "@angular/common";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from "@angular/material/datepicker";
import { MatError, MatFormField, MatSuffix } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatTooltip } from "@angular/material/tooltip";
import { DateClosestPipe } from "../../../common/pipes/date-closest";
import { MatIcon } from "@angular/material/icon";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";

@Component({
  selector: 'agendas-repeat-selector',
  providers: [],
  styleUrls: ['./repeat-selector.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogClose,
    MatDialogTitle,
    NgIf,
    MatIconButton,
    MatButton,
    MatDatepickerInput,
    MatFormField,
    MatInput,
    MatSuffix,
    MatProgressBar,
    MatTooltip,
    TranslateModule,
    DateClosestPipe,
    MatDialogContent,
    MatDialogActions,
    MatDatepicker,
    MatDatepickerToggle,
    MatIcon,
    MatError,
  ],
  templateUrl: './repeat-selector.html'
})
export class AgendasRepeatSelectorComponent implements AfterViewInit {

    public isLoading = false;
    public formTitle = '';
    public confirmButtonTitle = 'Repeat';
    public endDateFormControl: FormControl = new FormControl([
        Validators.required
    ]);
    public endDateMinDate: Date = new Date();

    private _slot: TimeslotRow = {} as TimeslotRow;
    constructor(
        public dialog: MatDialogRef<AgendasRepeatSelectorComponent>,
        private _toaster: MatSnackBar,
        protected utilsProvider: UtilsProvider,
        public _translater: TranslateService,
        @Inject(MAT_DIALOG_DATA) private _data : any
    ) {
        this.formTitle = this._data.formTitle;
        this.confirmButtonTitle = this._data.confirmButtonTitle;
        this._slot = this._data.slot;

        // date minimale pour la fin de la répétition
        // fromDate is a wall-clock time but the API tags it with a 'Z' (UTC) suffix;
        // strip the timezone so the min date is not shifted across midnight.
        const ld = moment(this.utilsProvider.ISODateToYmdHis(this._slot.timeslot!.fromDate!));
        this.endDateMinDate = ld.add(7, 'd').toDate();
    }

    public ngAfterViewInit() {
    }

    public onChooseClicked(): void {
        if (this.isValid()) {
            const d = new Date(this.endDateFormControl.value);
            const endDate = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
            this.dialog.close(endDate);
        } else {
            this.touchFields();
            this._toaster.open(this._translater.instant('Correct_form_errors'), '', { duration: 5000 });
        }
    }

    private isValid(): boolean {
        return !this.endDateFormControl.invalid;
    }

    private touchFields(): void {
        this.endDateFormControl.markAsTouched();
    }
}
